import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { initialReducers } from "./slices";
import ReducerManager from "./store/reducerManager";

// Create reducer manager with initial reducers
const reducerManager = new ReducerManager(initialReducers);

// Create store with initial reducers
const store = configureStore({ 
  reducer: reducerManager.getRootReducer(), 
  devTools: true 
});

// Set the store in reducer manager so it can replace reducers
reducerManager.setStore(store);

// Export reducer manager for lazy loading
export { reducerManager };

// Make reducer manager available globally for lazy loading
if (typeof window !== 'undefined') {
  window.__REDUCER_MANAGER__ = reducerManager;
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <React.Fragment>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
      </BrowserRouter>
    </React.Fragment>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();